import type { AnimationTrack } from "../../../shared/api-contract";
import { TimelineLane } from "./TimelineLane";

interface Props {
  tracks: AnimationTrack[];
  duration: number;
  selectedTrackId: string | null;
  labelOf: (track: AnimationTrack) => string;
  onSelectTrack: (id: string) => void;
  onRemoveTrack: (id: string) => void;
}

export function TrackList({ tracks, duration, selectedTrackId, labelOf, onSelectTrack, onRemoveTrack }: Props) {
  if (tracks.length === 0) {
    return (
      <span className="text-[12px] leading-snug text-ed-text-2">
        No tracks yet. Apply a preset above, or add a track below.
      </span>
    );
  }

  return (
    <div className="flex flex-col gap-1.5">
      {tracks.map((t) => (
        <div key={t.id} className="flex items-center gap-1.5">
          <div className="min-w-0 flex-1">
            <TimelineLane
              track={t}
              title={labelOf(t)}
              duration={duration}
              selected={selectedTrackId === t.id}
              onSelect={() => onSelectTrack(t.id)}
            />
          </div>
          <button
            onClick={() => onRemoveTrack(t.id)}
            className="shrink-0 rounded-md border border-ed-line px-2 py-1.5 text-[12px] font-medium text-ed-text-2 hover:border-ed-accent hover:text-ed-text"
          >
            Remove
          </button>
        </div>
      ))}
    </div>
  );
}
